var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.genres)?_c('BaseSection',{attrs:{"padded":""}},[_c('GenresList',{attrs:{"genres":_vm.genres}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }